import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

import type { PartNodeDetails, UseReorderPartNodeVariables } from './types';

export const useReorderPartNodes: MutationFunction<
  PartNodeDetails,
  UseReorderPartNodeVariables
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);
  return useMutation({
    mutationFn: ({ id, ...body }) => {
      return request<PartNodeDetails>(`/parts/nodes/${id}`, {
        query,
        init: {
          method: 'PATCH',
          body,
        },
      });
    },
    ...queryOptions,
  });
};
